import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  @Input() footerClass: string;
  @Input() isLoaded: boolean;
  
  currentYear: string; 

  constructor() { }

  ngOnInit() {
    const today = new Date(); // Get today's date
    this.currentYear = today.getFullYear().toString(); // Extract the current year
  }

}
